import { assign } from 'xstate5';

import { type ReorderMachineAction, type ReorderStep } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export const setPreviousStep: ReorderMachineAction<{ previousStep: ReorderStep }> = assign(
  (_args, params) => ({
    previousStep: params.previousStep,
  }),
);
